import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

/** El alta la usa el admin, el líder y el contador. */
export const agregarPersonaGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isAdmin() || userStore.isLider() || userStore.isContador()) {
    return true;
  }

  return router.createUrlTree(['/configuracion', 'mi-cuenta']);
};
